import { render } from "./PrivacyPolicy.vue?vue&type=template&id=67685698&scoped=true&ts=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=67685698&lang=scss&scoped=true"
import "./PrivacyPolicy.vue?vue&type=style&index=1&id=67685698&scoped=true&lang=scss"
import "./PrivacyPolicy.vue?vue&type=style&index=2&id=67685698&scoped=true&lang=scss"
import "./PrivacyPolicy.vue?vue&type=style&index=3&id=67685698&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67685698"]])

export default __exports__